import { PageHero, CTABand, SectionHead, Marquee } from "../components/site/Blocks";
import { Reveal } from "../components/site/Motion";
import { IMAGES } from "../data/content";

const VALUES = [
  { t: "Precision", d: "Every questionnaire, sample and dataset is checked before it reaches you." },
  { t: "Quality", d: "Best-in-class processes, no shortcuts, no excuses." },
  { t: "Agility", d: "A young team that moves fast and adapts as your questions evolve." },
  { t: "Value", d: "High-value research operations at genuinely competitive pricing." },
];

const DOMAINS = ["Consumer & Shopper", "Healthcare", "Technology", "Financial Services", "B2B & Industrial", "Media & Advertising", "Automotive", "Public & Social"];

export default function About() {
  return (
    <main data-testid="about-page">
      <PageHero
        testid="about-hero"
        label="About Wireaxis"
        lines={["Driven by youth.", <span className="font-serif-i">Grounded in expertise.</span>]}
        intro="Wireaxis is a fast-growing market research agency founded by a group of young, dynamic, enthusiastic and experienced professionals, backed by experts in various domains."
        image={IMAGES.team}
      />
      <section className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32" data-testid="about-story">
        <div className="grid gap-12 lg:grid-cols-12">
          <div className="lg:col-span-4"><p className="font-mono text-xs uppercase tracking-[0.22em] text-[var(--muted)]">Our story</p></div>
          <Reveal className="space-y-6 text-xl leading-relaxed tracking-tight sm:text-2xl lg:col-span-8">
            <p>We started Wireaxis because research should be both rigorous and responsive. Clients deserve answers they can trust, delivered at the pace their business moves.</p>
            <p className="text-[var(--muted)]">Our team pairs fresh energy with deep domain experience to provide efficient consultancy and high-value market research operations — with best-in-class quality and competitive pricing.</p>
          </Reveal>
        </div>
      </section>
      <section className="bg-[var(--paper-2)] py-24 sm:py-32" data-testid="about-values">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <SectionHead label="What we stand for" title={["Four principles,", "every project."]} />
          <div className="mt-16 grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {VALUES.map((v, i) => (
              <Reveal key={v.t} delay={i * 0.08} className="group rounded-[4px] border border-black/10 bg-white p-8 transition-colors duration-500 hover:bg-[var(--ink)] hover:text-white">
                <p className="font-mono text-xs text-[var(--muted)] group-hover:text-zinc-400">0{i + 1}</p>
                <h3 className="mt-16 text-3xl font-semibold tracking-tight">{v.t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-[var(--muted)] group-hover:text-zinc-300">{v.d}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>
      <section className="mx-auto max-w-[1400px] px-5 py-24 sm:px-8 sm:py-32" data-testid="about-experts">
        <SectionHead label="Domain expert bench" title={["Specialists for", <span className="font-serif-i">every sector.</span>]} aside="Our consultants and research leads bring hands-on experience across the domains below." />
        <div className="mt-14 flex flex-wrap gap-3">
          {DOMAINS.map((d, i) => (
            <Reveal key={d} delay={i * 0.04}>
              <span className="inline-block rounded-full border border-black/20 px-5 py-3 text-base font-medium transition-colors hover:border-[var(--cobalt)] hover:bg-[var(--cobalt)] hover:text-white">{d}</span>
            </Reveal>
          ))}
        </div>
      </section>
      <Marquee items={["Young", "Dynamic", "Enthusiastic", "Experienced", "Expert-backed", "Quality-obsessed"]} />
      <CTABand />
    </main>
  );
}
